import axios from 'axios';

// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://check.policypulsehq.com/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (userData) => api.post('/auth/register', userData)
};

// Products API
export const productsAPI = {
  getAll: () => api.get('/products'),
  getOne: (id) => api.get(`/products/${id}`),
  sync: () => api.post('/products/sync'),
  updateCost: (id, costPrice) => api.put(`/products/${id}/cost`, { cost_price: costPrice }),
  updateInventory: (id, quantity) => api.put(`/products/${id}/inventory`, { quantity })
};

// Orders API
export const ordersAPI = {
  getAll: (params) => api.get('/orders', { params }),
  sync: (dateRange) => api.post('/orders/sync', dateRange),
  getStats: (params) => api.get('/orders/stats', { params })
};

// Reports API
export const reportsAPI = {
  getDashboard: () => api.get('/reports/dashboard'),
  getProfitReport: (params) => api.get('/reports/profit', { params }),
  getProductReport: (params) => api.get('/reports/products', { params }),
  exportOrders: (params) => api.get('/reports/export/orders', { 
    params,
    responseType: 'blob'
  })
};

export default api;